import { render, staticRenderFns } from "./AddNewLearningItem.vue?vue&type=template&id=6e6813e5&scoped=true&"
import script from "./AddNewLearningItem.vue?vue&type=script&lang=js&"
export * from "./AddNewLearningItem.vue?vue&type=script&lang=js&"
import style0 from "./AddNewLearningItem.vue?vue&type=style&index=0&id=6e6813e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6813e5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VOverlay,VRow,VSheet,VTextField,VToolbarTitle})
